import { render, staticRenderFns } from "./currentNews.vue?vue&type=template&id=4672572a&scoped=true"
import script from "./currentNews.vue?vue&type=script&lang=js"
export * from "./currentNews.vue?vue&type=script&lang=js"
import style0 from "./currentNews.vue?vue&type=style&index=0&id=4672572a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4672572a",
  null
  
)

export default component.exports